import { JobMatchesQueryFilter } from "../../../../models/jobMatchesQueryFilter";
import { CandidatesInfiniteScrollContainer } from "./candidates-infinite-scroll-container";
import * as CandidateSendOutreachEmailModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-send-outreach-email-modal.html';
import { FormalizeCompany, FormalizeRequisition, FormalizeJobMatch } from "src/app/public/app/models/formalizePayload";
class CandidateJobMatchesWorkflowController {
    /*@ngInject*/
    constructor($rootScope, $state, $uibModal, $timeout, assessmentService, jobMatchDragAndDropService, requisitionService, companyService, jobMatchService, jobService, planService, webSocketsService, userRoleService, alertsAndNotificationsService, debounceService, browserService, candidateService, utilityService, outreachService, stateManagementStorageService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.assessmentService = assessmentService;
        this.jobMatchDragAndDropService = jobMatchDragAndDropService;
        this.requisitionService = requisitionService;
        this.companyService = companyService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.planService = planService;
        this.webSocketsService = webSocketsService;
        this.userRoleService = userRoleService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.debounceService = debounceService;
        this.browserService = browserService;
        this.candidateService = candidateService;
        this.utilityService = utilityService;
        this.outreachService = outreachService;
        this.stateManagementStorageService = stateManagementStorageService;
    }
    $onInit() {
        // variables
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this.isStaffingFlag = this.companyService.isStaffingCompany();
        this.userId = this.$rootScope.userDetails.id;
        this.candidatesObject = {};
        this.enabledWorkflowSteps = {};
        this.workflowStepNames = [];
        this.activityMap = [];
        this.jobMatchStates = [];
        this.vendorsList = [];
        this.selectedJobMatchStates = [];
        this.selectedVendors = [];
        this.salaryDurationOptions = [];
        this.requisitionStatusesToDisableAddActions = ['Sourced', 'Paused', 'Canceled', 'Completed'];
        this.jobInfo = {};
        this.requisitionStatus = '';
        this.hiringManagersList = [];
        this.allJobMatches = [];
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this.candidatesStepChangedInBackgroundMessage = "";
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this.assessmentDetails == null;
        this.valueAssessmentDetails == null;
        this.displaySelectedFilterContainer = {};
        this.displaySelectedFilterContainer.searchString = "";
        this.displaySelectedFilterContainer.jobMatchStates = [];
        this.displaySelectedFilterContainer.vendors = [];
        this.displaySelectedFilterContainer.outreachStateFilters = [];
        this.savedFilters = null;
        this.savedDisplayedWorkflowSelectedFilter = null;
        let savedFilters = this.stateManagementStorageService.getScreenState(`candidateWorkflowScreen-${this.userId}`);
        if (savedFilters && !_.isEmpty(savedFilters)) {
            savedFilters.jobMatchIds = [];
            this.savedFilters = _.cloneDeep(savedFilters);
        }
        else {
            this.savedFilters = this.globalQueryFilterObject;
        }
        let filter = angular.copy(this.displaySelectedFilterContainer);
        let savedDisplayedWorkflowSelectedFilter = this.stateManagementStorageService.getScreenState(`candidateWorkflowScreen-displayFilter-${this.userId}`);
        if (savedDisplayedWorkflowSelectedFilter && !_.isEmpty(savedDisplayedWorkflowSelectedFilter)) {
            this.displaySelectedFilterContainer = _.cloneDeep(savedDisplayedWorkflowSelectedFilter);
            this.savedDisplayedWorkflowSelectedFilter = _.cloneDeep(savedDisplayedWorkflowSelectedFilter);
        }
        else {
            this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-displayFilter-${this.userId}`, filter);
        }
        this.candidateWorkFlowFilterItemsSelected = [];
        this.primaryHiringManager = [];
        this.endClient = null;
        this.outreachFilters = [];
        this.selectedOutreachStates = [];
        this.workflowFirstStep = "";
        //flags
        this.isFiltersChanged = false;
        this.showFilterPanel = false;
        this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
        this.showRefreshWorkFlowAction = false;
        this.hideSearchStringFlag = false;
        this.jobIntegrationEnabled = false;
        this.disableAddActionsFlag = false;
        this.disableAssignRecruiterActionsFlag = false;
        this.disableSendTechAssessmentActionsFlag = false;
        this.disableValueAssessmentActionsFlag = false;
        this.disableCancelTechAssessmentActionsFlag = false;
        this.disableCancelValueAssessmentActionsFlag = false;
        this.disableReleaseCandidatesActionsFlag = false;
        this.disableMarkAsNotInterestedActionsFlag = false;
        this.jobInfoLoadedFlag = false;
        this.isJobBoardServiceUp = true;
        this.jobMatchStatesLoadedFlag = false;
        this.showVendorFilterFlag = false;
        this.vendorsListLoadedFlag = false;
        this.showGlobalAssignRecruiterAction = true;
        this.showGlobalTechAssessmentAction = false;
        this.showGlobalCancelTechAssessmentAction = false;
        this.showGlobalValueAssessmentAction = false;
        this.showGlobalCancelValueAssessmentAction = false;
        this.enableSelectJobMatchesOptions = false;
        this.selectAllJobMatchesFlag = false;
        this.techAssessmentInfoLoading = true;
        this.valueAssessmentInfoLoading = true;
        this.isTechAssessmentInfoExists = false;
        this.isValueAssessmentInfoExists = false;
        this.displayCandidateWorkFlowFilter = false;
        this.showDisplayFilterIcon = true;
        this.emptyJobMatchSelectedFilter = false;
        this.isRecruitersPopoverOpen = false;
        this.isHiringManagerPopoverOpen = false;
        this.isOutreachEnabled = false;
        this.refreshReRunScore = false;
        this.scoringInProgress = false;
        this.outreachFiltersLoadedFlag = true;
        this.jobMatchInProgress = false;
        setTimeout(() => {
            //drag scroll handling
            this._setDragConfig();
        }, 2000);
        this.getOutreachFilters();
        this._setDebounceService();
        this._listenToWorkflowStateUpdate();
        this._listenToJobMatchRemove();
        this._getAllActivityTypes();
        this._getAllJobMatchStates();
        this._getPlanDetails();
        this._getSalaryDurationOptions(() => {
            this._getJobDetails(() => {
                this.requisitionStatus = this.jobInfo.requisitionStatus;
                if (this.jobInfo.hiringManagerDetails && this.jobInfo.hiringManagerDetails.length > 0) {
                    if (this.jobInfo.hiringManagerDetails.length == 1) {
                        this.primaryHiringManager = this.jobInfo.hiringManagerDetails;
                    }
                    else {
                        this.jobInfo.hiringManagerDetails.map(hiringManager => {
                            if (hiringManager.isPrimary || hiringManager.isPoc) {
                                this.primaryHiringManager.push(hiringManager);
                            }
                            else {
                                this.hiringManagersList.push(hiringManager);
                            }
                        });
                    }
                    if (this.primaryHiringManager.length == 0) {
                        this.primaryHiringManager = this.hiringManagersList.slice(1);
                    }
                }
                this.pointOfContact = this.jobInfo.pointOfContact;
                this.endClient = this.jobInfo.endClient ? this.jobInfo.endClient.name : this.jobInfo.endClient;
                if (this.requisitionStatusesToDisableAddActions.indexOf(this.requisitionStatus) != -1) {
                    this.disableAddActionsFlag = true;
                }
                if (this.isCorporateFlag && this.jobInfo.sharedRequisition) {
                    // do not show assign recruiter global action
                    this.showGlobalAssignRecruiterAction = false;
                    // show the vendors filter
                    this.showVendorFilterFlag = true;
                    this._getVendors();
                }
                if (this.jobId != '') {
                    this.getEnabledWorkflowSteps(() => {
                        angular.forEach(this.enabledWorkflowSteps, (val, key) => {
                            if (val == 'Tech Assessment') {
                                this.showGlobalTechAssessmentAction = true;
                                this.showGlobalCancelTechAssessmentAction = true;
                            }
                            else if (val == 'Value Assessment') {
                                this.showGlobalValueAssessmentAction = true;
                                this.showGlobalCancelValueAssessmentAction = true;
                            }
                        });
                        this._createCandidatesObject();
                        // _getAllJobMatches();
                    });
                }
                else {
                    this._createCandidatesObject();
                }
                // $(window).bind('resize', _setCandidateStateWrapperColumnContainerHeight);
                // catch the event to refresh the workflow
                this.$rootScope.$on('refreshJobWorkflow', (event, data) => {
                    this.resetCandidateJobMatches();
                });
                // $("#candidateJobMatchesWorkflowSearchText").keyup(this.debounceService.debounce(this.queryJobMatches, 500));
                this.jobInfo.listOfAllRecruitersAndHiringManagers = [...this.jobInfo.allRecruitersList, ...this.hiringManagersList, ...this.primaryHiringManager];
                if (this.pointOfContact) {
                    this.jobInfo.listOfAllRecruitersAndHiringManagers = this.jobInfo.listOfAllRecruitersAndHiringManagers.filter(user => user.name != this.pointOfContact);
                    this.jobInfo.listOfAllRecruitersAndHiringManagers.push({ name: this.pointOfContact });
                }
            });
        });
        this._checkJobBoardsSearchAvailability();
        $(document).ready(() => {
            $("#workflow-search-panel").hide();
            $(document).off("click", "#open-filter").on("click", "#open-filter", () => {
                $("#workflow-search-panel").animate({
                    height: 'toggle'
                });
                this.showFilterPanel = !this.showFilterPanel;
            });
        });
        this.getAllPreferredJobTypes();
        this._checkIfOutreachEnabled();
        this.getJobScoringJobStatus();
    }
    getJobScoringJobStatus() {
        this.jobService.getJobScoringJobStatus(this.jobId, data => {
            this.scoringInProgress = data;
            if (this.scoringInProgress) {
                let message = "Job matching is in progress. You will be notified once it's completed...";
                this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _checkTechAssessmentIdExists() {
        if (this.jobInfo.techAssessmentId) {
            this.isTechAssessmentInfoExists = true;
        }
    }
    _getAssessmentDetails() {
        if (this.assessmentDetails == null) {
            this.assessmentService.getAssessmentDetails(this.jobInfo.techAssessmentId, this.jobId, (data) => {
                this.assessmentDetails = data;
                this._setTotalDuration();
                this.techAssessmentInfoLoading = false;
            }, (error) => {
                // this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    _setTotalDuration() {
        this.assessmentDetails.totalDuration = 0;
        angular.forEach(this.assessmentDetails.sections, (section, key) => {
            this.assessmentDetails.totalDuration = this.assessmentDetails.totalDuration + section.duration;
        });
    }
    _checkValueAssessmentIdExists() {
        if (this.jobInfo.valueAssessmentId) {
            this.isValueAssessmentInfoExists = true;
        }
    }
    _getValueAssessmentDetails() {
        if (this.jobInfo.valueAssessmentId != null && this.valueAssessmentDetails == null) {
            this.assessmentService.getAssessmentDetails(this.jobInfo.valueAssessmentId, this.jobId, (data) => {
                this.valueAssessmentDetails = data;
                this._setValueAssessmentDuration();
                this.valueAssessmentInfoLoading = false;
            }, (error) => {
                // this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    _setValueAssessmentDuration() {
        this.valueAssessmentDetails.totalDuration = 0;
        angular.forEach(this.valueAssessmentDetails.sections, (section, key) => {
            this.valueAssessmentDetails.totalDuration = this.valueAssessmentDetails.totalDuration + section.duration;
        });
    }
    _massageRequisitionCardInfo(data) {
        let massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
        angular.merge(this.jobInfo, massagedRequisitionInfo.data);
    }
    onGlobalFilterChange() {
        this.isFiltersChanged = true;
        if (!this.showFilterPanel) {
            $("#workflow-search-panel").animate({
                height: 'toggle'
            });
            this.showFilterPanel = true;
        }
        if (this._onEnterKeyPress(event)) {
            this.queryJobMatches();
        }
    }
    _onEnterKeyPress(event) {
        return event && event.keyCode == 13;
    }
    _setDragConfig() {
        this.container = $('#steps-container');
        this.offset = this.container.offset();
        this.offsetWidth = this.offset.left + this.container.width();
        this.offsetHeight = this.offset.top + this.container.height();
        this.draggableCard = $('.draggable-card');
        this.intRightHandler = null;
        this.intLeftHandler = null;
        this.intTopHandler = null;
        this.intBottomHandler = null;
        this.distance = 250;
        this.timer = 40;
        this.step = 50;
        if (this.browserService.isGoogleChrome()) {
            $('#steps-container').bind("drag", (e) => {
                // $('.row-horizon').bind("drag", (e) => {
                this._drag(e);
            });
        }
    }
    _setDebounceService() {
        this.queryJobMatches = _.debounce(this.queryJobMatches, 500);
    }
    _listenToWorkflowStateUpdate() {
        this.webSocketsService.receiveWorkflowUpdate().then(null, null, (stateChange) => {
            if (this.jobId == stateChange.reqId) {
                this.jobMatchInProgress = stateChange.jobMatchInProgress;
            }
            if (stateChange.refreshWorkflow && this.jobId == stateChange.reqId) {
                if (stateChange.reRunScoringDone) {
                    // After Re Run Scoring is done. Show re run score refresh message, if 'jobMatchId' is received as null.
                    this.showRefreshWorkFlowAction = true;
                    this.refreshReRunScore = true;
                    this.candidatesStepChangedInBackgroundMessage = "Re-run for candidates in workflow done.";
                }
                else {
                    if (!stateChange.jobMatchInProgress) {
                        this.showRefreshWorkFlowAction = true;
                        this.refreshReRunScore = false;
                        this.countOfCandidatesWhoseStepHasChangedInBackground++;
                        if (this.countOfCandidatesWhoseStepHasChangedInBackground == 1) {
                            this.candidatesStepChangedInBackgroundMessage = " Card updated.";
                        }
                        else {
                            this.candidatesStepChangedInBackgroundMessage = " Cards updated.";
                        }
                    }
                }
            }
            this.$rootScope.$emit("REFRESH_JOB_MATCH_CARD", stateChange);
        });
    }
    _listenToJobMatchRemove() {
        this.removeJobMatchListener = this.$rootScope.$on("REMOVE_JOB_MATCH_CARD", (event, jobMatch) => {
            this.resetCandidateJobMatches();
            let candidateName = jobMatch.firstName;
            if (jobMatch.lastName) {
                candidateName += ' ' + jobMatch.lastName;
            }
            let message = `${candidateName} has been removed as the candidate no longer matches the job requirements`;
            this.alertsAndNotificationsService.showAlert("Job Match Removed", message, "warning");
        });
    }
    _getAllActivityTypes() {
        this.jobService.getActivityTypes((data) => {
            this.activityMap = [];
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getAllJobMatchStates() {
        this.jobMatchStatesLoadedFlag = false;
        this.jobMatchService.getAllJobMatchStates((data) => {
            angular.forEach(data.candidateWorkflowCardStatus, (stepVal, stepKey) => {
                let stepEntry = {};
                stepEntry.name = stepVal.status;
                stepEntry.value = stepVal.status;
                if (stepVal.status === 'No longer a match') {
                    stepEntry.label = "<span style='color: #e84e40; font-weight: bold;'>" + stepVal.status + "</span>";
                }
                else {
                    stepEntry.label = "<b>" + stepVal.status + "</b>";
                }
                stepEntry.stepGroup = true;
                this.jobMatchStates.push(stepEntry);
                angular.forEach(stepVal.states, (stateVal, stateKey) => {
                    let stateEntry = {};
                    stateEntry.name = stateVal;
                    stateEntry.value = stateVal;
                    if (stateVal === 'No longer a match') {
                        stateEntry.label = "<span style='color: #e84e40;'>" + stateVal + "</span>";
                    }
                    else {
                        stateEntry.label = stateVal;
                    }
                    stateEntry.ticked = false;
                    this.jobMatchStates.push(stateEntry);
                });
                stepEntry = {};
                stepEntry.stepGroup = false;
                this.jobMatchStates.push(stepEntry);
            });
            this.jobMatchStatesLoadedFlag = true;
            if (this.savedFilters && this.savedFilters.workflowStates && this.savedFilters.workflowStates.length > 0) {
                this.selectedJobMatchStates = this.jobMatchStates.filter(jobMatch => jobMatch.value && !jobMatch.stepGroup && this.savedFilters.workflowStates.some(selected => selected == jobMatch.value));
                this.selectedJobMatchStates.forEach(state => state.ticked = true);
                this.globalQueryFilterObject.workflowStates = this.selectedJobMatchStates.map((val, index) => {
                    return val.value;
                });
            }
            if (this.savedDisplayedWorkflowSelectedFilter && this.savedDisplayedWorkflowSelectedFilter.jobMatchStates && this.savedDisplayedWorkflowSelectedFilter.jobMatchStates.length !== 0) {
                this.displaySelectedFilterContainer.jobMatchStates = [];
                this.displaySelectedFilterContainer.jobMatchStates = this.selectedJobMatchStates.map((val, index) => {
                    return val.value;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getPlanDetails() {
        this.planService.getCompanyPlanDetails(this.companyId, (data) => {
            if (!_.isNull(data) && typeof data === 'object' && !_.isNull(data.features) && data.features.length) {
                var jobIntegrationDetails = _.find(data.features, { 'name': "Job Board Integration", 'available': true });
                this.jobIntegrationEnabled = _.isUndefined(jobIntegrationDetails) ? false : true;
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getSalaryDurationOptions(successCallback) {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getJobDetails(successCallback) {
        this.jobInfoLoadedFlag = false;
        this.jobService.getRequisitionDetails(this.jobId, this.companyId, (data) => {
            angular.merge(this.jobInfo, data);
            this._massageRequisitionCardInfo(this.jobInfo);
            this._checkTechAssessmentIdExists();
            this._checkValueAssessmentIdExists();
            this.headerInfo = this._getHeaderInfo();
            let headerDetailsList = this.headerInfo.split("@");
            if (headerDetailsList && headerDetailsList.length > 0) {
                this.companyLabel = headerDetailsList[0];
                if (headerDetailsList.length > 1) {
                    this.locationLabel = headerDetailsList[1];
                }
            }
            else {
                this.companyLabel = this.headerInfo;
            }
            this.jobInfoLoadedFlag = true;
            this._setGlobalActionsPermission();
            this.jobMatchInProgress = data.jobMatchInProgress;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getHeaderInfo() {
        let info = this.jobService.getJobLocationInfoText(this.jobInfo, this.isCorporateFlag);
        this.jobLocation = info.jobLocation;
        return info.headerInfo;
    }
    _setGlobalActionsPermission() {
        if (this.jobInfo.requisitionStatus == 'Paused' || this.jobInfo.requisitionStatus == 'Canceled') {
            this.disableAssignRecruiterActionsFlag = true;
            this.disableSendTechAssessmentActionsFlag = true;
            this.disableValueAssessmentActionsFlag = true;
            this.disableCancelTechAssessmentActionsFlag = true;
            this.disableCancelValueAssessmentActionsFlag = true;
            this.disableReleaseCandidatesActionsFlag = true;
            this.disableMarkAsNotInterestedActionsFlag = true;
        }
    }
    _getVendors() {
        this.vendorsListLoadedFlag = false;
        this.jobService.getAssignedVendors(this.jobId, (data) => {
            this.vendorsList = data;
            if (this.savedFilters && this.savedFilters.vendors && this.savedFilters.vendors.length > 0) {
                this.selectedVendors = this.vendorsList.filter(vendor => this.savedFilters.vendors.some(selected => selected == vendor.vendorId));
                this.selectedVendors.forEach(vendor => vendor.ticked = true);
                this.globalQueryFilterObject.vendors = this.selectedVendors.map((val, index) => {
                    return val.vendorId;
                });
            }
            if (this.savedDisplayedWorkflowSelectedFilter && this.savedDisplayedWorkflowSelectedFilter.vendors && this.savedDisplayedWorkflowSelectedFilter.vendors.length !== 0) {
                this.displaySelectedFilterContainer.vendors = [];
                this.displaySelectedFilterContainer.vendors = this.selectedVendors.map((val, index) => {
                    return val.vendorName;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
            }
            this.vendorsListLoadedFlag = true;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getEnabledWorkflowSteps(successCallback) {
        this.jobService.getEnabledWorkflowSteps(this.jobId, (data) => {
            this.enabledWorkflowSteps = data;
            this.workflowStepNames = [];
            angular.forEach(this.enabledWorkflowSteps, (stepName, key) => {
                this.workflowStepNames.push(stepName);
            });
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _createCandidatesObject() {
        this.candidatesObject = {};
        if (this.jobId != '') {
            angular.forEach(this.enabledWorkflowSteps, (val, key) => {
                let tempVal = val;
                let infoVariableStringArray = tempVal.split(" ");
                let infoVariableString = '';
                let identifierString = '';
                if (infoVariableStringArray.length > 1) {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + infoVariableStringArray[1] + 'Info';
                    identifierString = infoVariableStringArray[0].toLowerCase() + '-' + infoVariableStringArray[1].toLowerCase();
                }
                else {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + 'Info';
                    identifierString = infoVariableStringArray[0].toLowerCase();
                }
                this.candidatesObject[infoVariableString] = new CandidatesInfiniteScrollContainer(val, infoVariableString, identifierString, this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService);
            });
        }
        else {
            this.candidatesObject = {
                recruiterScreeningInfo: new CandidatesInfiniteScrollContainer('Recruiter Screening', 'recruiterScreeningInfo', 'recruiter-screening', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                //qualifiedInfo:  new CandidatesInfiniteScrollContainer('Qualified','qualifiedInfo','soft-qualified'),
                techAssessmentInfo: new CandidatesInfiniteScrollContainer('Tech Assessment', 'techAssessmentInfo', 'tech-assessment', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                valueAssessmentInfo: new CandidatesInfiniteScrollContainer('Value Assessment', 'valueAssessmentInfo', 'value-assessment', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                verificationInfo: new CandidatesInfiniteScrollContainer('Verification', 'verificationInfo', 'verification', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                phoneScreenInfo: new CandidatesInfiniteScrollContainer('Phone Screen', 'phoneScreenInfo', 'phone-screen', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                interviewInfo: new CandidatesInfiniteScrollContainer('Interview', 'interviewInfo', 'interview', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                //likelyInfo:  new CandidatesInfiniteScrollContainer('Likely','likelyInfo','soft-qualified'),
                notInterestedInfo: new CandidatesInfiniteScrollContainer('Not Interested', 'notInterestedInfo', 'not-interested', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService),
                releasedInfo: new CandidatesInfiniteScrollContainer('Released', 'releasedInfo', 'released', this.userId, this.companyId, this.jobId, this.globalQueryFilterObject, this.workflowStepNames, this.jobMatchDragAndDropService, this.jobMatchService, this.alertsAndNotificationsService)
            };
        }
        this.$timeout(() => {
            this.workflowFirstStep = Object.values(this.candidatesObject)[0].workflowStepNames[0];
        }, 500);
    }
    resetCandidateJobMatches() {
        this.showRefreshWorkFlowAction = false;
        this.refreshReRunScore = false;
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this._createCandidatesObject();
        angular.forEach(this.candidatesObject, (val, key) => {
            let tempWorkflowSteps = val.jobMatchesQueryFilter.workflowSteps;
            val.jobMatchesQueryFilter = angular.copy(this.globalQueryFilterObject);
            val.jobMatchesQueryFilter.workflowSteps = tempWorkflowSteps;
            this._clearJobMatchIdsFilterOnAnyOtherFilterChange(val.jobMatchesQueryFilter);
            val.getNext();
        });
    }
    _clearJobMatchIdsFilterOnAnyOtherFilterChange(jobMatchesQueryFilter) {
        jobMatchesQueryFilter.jobMatchIds = [];
    }
    selectAllCandidates() {
        this.selectAllJobMatchesFlag = true;
        var selectingAllCandidatesDialog = bootbox.dialog({
            message: '<span class="loading-message"> Selecting Candidates <i class="fa fa-spinner fa-spin"></i></span>',
            closeButton: false
        });
        this._getAllJobMatches(() => {
            angular.forEach(this.candidatesObject, (val, key) => {
                angular.forEach(val.candidates, (candidate, k) => {
                    candidate.selectedFlag = true;
                });
            });
            selectingAllCandidatesDialog.modal('hide');
        });
    }
    _getAllJobMatches(successCallback) {
        let steps = [];
        angular.forEach(this.enabledWorkflowSteps, (step, key) => {
            steps.push(step);
        });
        let jobMatchesQueryFilter = angular.copy(this.globalQueryFilterObject);
        jobMatchesQueryFilter.workflowSteps = angular.copy(steps);
        this.jobMatchService.getJobMatchCandidates(this.userId, this.companyId, 1, 2000, this.jobId, jobMatchesQueryFilter, (data) => {
            this.allJobMatches = [];
            angular.forEach(this.enabledWorkflowSteps, (val, key) => {
                var tempVal = val;
                var infoVariableStringArray = tempVal.split(" ");
                var infoVariableString = '';
                var identifierString = '';
                if (infoVariableStringArray.length > 1) {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + infoVariableStringArray[1] + 'Info';
                }
                else {
                    infoVariableString = infoVariableStringArray[0].toLowerCase() + 'Info';
                }
                var tempJobMatches = JSON.parse(data[infoVariableString]);
                angular.forEach(tempJobMatches, (jobMatch, key) => {
                    jobMatch.selectFlag = false;
                    this.allJobMatches.push(jobMatch);
                });
            });
            this.enableSelectJobMatchesOptions = true;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getAllPreferredJobTypes() {
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _checkIfOutreachEnabled() {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    }
    deSelectAllCandidates() {
        this.selectAllJobMatchesFlag = false;
        angular.forEach(this.candidatesObject, (val, key) => {
            angular.forEach(val.candidates, (candidate, k) => {
                candidate.selectedFlag = false;
            });
        });
    }
    _checkJobBoardsSearchAvailability() {
        this.jobService.checkJobBoardsSearchAvailability((data) => {
            this.isJobBoardServiceUp = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setCandidateStateWrapperColumnContainerHeight() {
        var windowHeight = $(window).height();
        var containerHeight = windowHeight - 10;
        containerHeight = parseInt(containerHeight) + 'px';
        $(".candidate-state-wrapper-column-container").css('height', containerHeight);
    }
    displaySelectedFilterToggle() {
        if (this.displayCandidateWorkFlowFilter) {
            $("#display-candidate-workflow-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.showDisplayFilterIcon = !this.showDisplayFilterIcon;
        }
    }
    addToDisplayFilters(event) {
        switch (event) {
            case 'search':
                this.displaySelectedFilterContainer.searchString = this.globalQueryFilterObject.searchString;
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            default:
                break;
        }
    }
    _setObjectVariableName(currentObject) {
        let selectedFilterVariableNameObj = {
            jobMatchStates: "Job Match States", vendors: "Vendors", searchString: "Search", outreachStateFilters: "Outreach States"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    }
    isFilterValueArray(value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    }
    setSelectedFilterItems(filtersItemsSelected) {
        this.emptyJobMatchSelectedFilter = false;
        for (var key in filtersItemsSelected) {
            if (filtersItemsSelected.hasOwnProperty(key)) {
                var obj = filtersItemsSelected[key];
                if (obj.length > 0) {
                    this.displayCandidateWorkFlowFilter = true;
                    this.displaySelectedFilterObj = {};
                    if (this.candidateWorkFlowFilterItemsSelected.length !== 0) {
                        this.candidateWorkFlowFilterItemsSelected.forEach((filterItem) => {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.candidateWorkFlowFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.candidateWorkFlowFilterItemsSelected.length > 0) {
                        this.candidateWorkFlowFilterItemsSelected = this.candidateWorkFlowFilterItemsSelected.filter(item => item.variable !== this.displaySelectedFilterObj.variable);
                    }
                    this.candidateWorkFlowFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.candidateWorkFlowFilterItemsSelected.length > 0) {
                        this.candidateWorkFlowFilterItemsSelected = this.candidateWorkFlowFilterItemsSelected.filter(item => item.filter !== key);
                    }
                }
            }
        }
        if (this.candidateWorkFlowFilterItemsSelected.length === 0) {
            if (this.candidatesObject && this.candidatesObject.notInterestedInfo && !this.candidatesObject.notInterestedInfo.isFilterOn) {
                this.displayCandidateWorkFlowFilter = false;
            }
            else {
                this.emptyJobMatchSelectedFilter = true;
            }
        }
    }
    _deleteSelectedItem(currentObject, filtersItemsDeleted) {
        switch (currentObject.variable) {
            case 'searchString':
                this.globalQueryFilterObject.searchString = '';
                this.displaySelectedFilterContainer.searchString = '';
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            case 'jobMatchStates':
                this.jobMatchStates.forEach((jobMatch, index) => {
                    if (jobMatch.value === filtersItemsDeleted) {
                        jobMatch.ticked = false;
                        this.selectedJobMatchStates = this.selectedJobMatchStates.filter(item => item.value !== filtersItemsDeleted);
                    }
                });
                this.onFilterItemClick('selectedClients', 'JobMatchStates');
                break;
            case 'vendors':
                this.vendorsList.forEach((vendor, index) => {
                    if (vendor.vendorName === filtersItemsDeleted) {
                        vendor.ticked = false;
                        this.selectedVendors = this.selectedVendors.filter(item => item.vendorName !== filtersItemsDeleted);
                    }
                });
                this.onFilterItemClick('selectedVendors', 'Vendors');
                break;
            case 'outreachStateFilters':
                this.outreachFilters.forEach((outreachState, index) => {
                    if (outreachState.name === filtersItemsDeleted) {
                        outreachState.ticked = false;
                        this.selectedOutreachStates = this.selectedOutreachStates.filter(item => item.name !== filtersItemsDeleted);
                    }
                });
                this.onFilterItemClick('selectedOutreachStates', 'OutreachStates');
                break;
            default:
                break;
        }
    }
    deletedSelectedFilterItem(filtersItemsDeleted) {
        for (var key in this.displaySelectedFilterContainer) {
            if (this.displaySelectedFilterContainer.hasOwnProperty(key)) {
                var obj = this.displaySelectedFilterContainer[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(filtersItemsDeleted)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, filtersItemsDeleted);
                    }
                }
                else {
                    if (obj == filtersItemsDeleted) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, filtersItemsDeleted);
                    }
                }
            }
        }
    }
    queryJobMatches() {
        this.isFiltersChanged = false;
        this.showRefreshWorkFlowAction = false;
        this.refreshReRunScore = false;
        this.countOfCandidatesWhoseStepHasChangedInBackground = 0;
        this._createCandidatesObject();
        angular.forEach(this.candidatesObject, (val, key) => {
            var tempWorkflowSteps = val.jobMatchesQueryFilter.workflowSteps;
            val.jobMatchesQueryFilter = angular.copy(this.globalQueryFilterObject);
            val.jobMatchesQueryFilter.workflowSteps = tempWorkflowSteps;
            this._clearJobMatchIdsFilterOnAnyOtherFilterChange(val.jobMatchesQueryFilter);
            val.jobMatchesQueryFilter.workflowStates = val.jobMatchesQueryFilter.workflowStates.filter(state => state);
            val.getNext();
        });
        //get all job matches for select/deselect
        if (this.selectAllJobMatchesFlag) {
            this.selectAllCandidates();
        }
        // Hide Display Filter
        if (this.candidateWorkFlowFilterItemsSelected.length === 0) {
            this.displayCandidateWorkFlowFilter = false;
            this.showDisplayFilterIcon = true;
        }
        this.$timeout(() => {
            this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-${this.userId}`, this.globalQueryFilterObject);
            // Display Selected Filter
            this.stateManagementStorageService.setScreenState(`candidateWorkflowScreen-displayFilter-${this.userId}`, this.displaySelectedFilterContainer);
        }, 200);
    }
    resetWorkflowFilters() {
        this.isFiltersChanged = true;
        angular.forEach(this.jobMatchStates, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.vendorsList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.outreachFilters, (val, key) => {
            val.ticked = false;
        });
        this.$timeout(() => {
            this.globalQueryFilterObject = new JobMatchesQueryFilter();
        }, 100);
        //Reset Display Filter click events
        this.displaySelectedFilterContainer = { searchString: '', jobMatchStates: [], vendors: [], outreachStateFilters: [] };
        this.setSelectedFilterItems(this.displaySelectedFilterContainer);
    }
    performActionMultiple(action) {
        var selectedCandidateJobMatches = [];
        if (this.selectAllJobMatchesFlag) {
            selectedCandidateJobMatches = angular.copy(this.allJobMatches);
            var unSelectedCandidateJobMatches = [];
            //get unselected candidates
            angular.forEach(this.candidatesObject, (val, key) => {
                angular.forEach(val.candidates, (candidate, k) => {
                    if (!candidate.selectedFlag) {
                        unSelectedCandidateJobMatches.push(candidate);
                    }
                });
            });
            //remove unselected candidates from selected candidates
            angular.forEach(unSelectedCandidateJobMatches, (unSelectedJobMatch, key) => {
                _.remove(selectedCandidateJobMatches, { jobMatchId: unSelectedJobMatch.jobMatchId });
            });
        }
        else {
            angular.forEach(this.candidatesObject, (val, key) => {
                angular.forEach(val.candidates, (candidate, k) => {
                    if (candidate.selectedFlag) {
                        selectedCandidateJobMatches.push(candidate);
                    }
                });
            });
        }
        if (action == "addCandidatesFromJobBoards" && !this.isJobBoardServiceUp) {
            this.alertsAndNotificationsService.showBannerMessage("Job Board Service is currently unavailable.", 'danger');
            return;
        }
        if (action == 'compareCandidates' && selectedCandidateJobMatches.length < 2) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Too few Candidates Chosen</strong></div>",
                message: "Please select at least two candidates to compare.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (action == 'compareCandidates' && selectedCandidateJobMatches.length > 3) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Too Many (" + selectedCandidateJobMatches.length + ") Candidates Chosen</strong></div>",
                message: "A maximum of 3 candidates can be compared at once. <br> Please choose 3 or fewer cards.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if ((action == 'sendTechAssessment' || action == 'cancelTechAssessment' || action == 'sendValueAssessment' || action == 'cancelValueAssessment') && selectedCandidateJobMatches.length > 25) {
            var message = '';
            if (action == 'sendTechAssessment' || action == 'sendValueAssessment') {
                message = "A maximum of 25 candidates can be sent an assessment at once. <br> Please choose 25 or fewer cards.";
            }
            else if (action == 'cancelTechAssessment' || action == 'cancelValueAssessment') {
                message = "Assessment can be cancelled for a maximum of 25 candidates at once. <br> Please choose 25 or fewer cards.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Too Many (" + selectedCandidateJobMatches.length + ") Candidates Chosen</strong></div>",
                message: message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (action != 'addCandidates' && action != 'jobProfile' && action != 'associateCandidates' && action != 'compareCandidates' && action != 'addCandidatesFromJobBoards' && selectedCandidateJobMatches.length == 0) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Cards Selected!</strong></div>",
                message: "Please select at least one card to perform this action.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (action == "sendCandidateOutreach" && selectedCandidateJobMatches.length > 0) {
            let windowClass = 'four-dot-five-modal-small';
            let validCandidatesToSendOutreachEmail = [];
            let notValidCandidatesToSendOutreachEmail = [];
            let selectedJobMatchesForOutreach = [];
            let isSingleCandidateSelected = false;
            let candidateId = '';
            let candidateType = '';
            selectedCandidateJobMatches.map((candidate, index) => {
                let candidateFirstName = candidate.firstName ? candidate.firstName + " " : "";
                let candidateLastName = candidate.lastName ? candidate.lastName : "";
                let tempObject = {};
                tempObject.jobMatchId = candidate.jobMatchId;
                tempObject.candidateId = candidate.id;
                tempObject.workflowStepName = candidate.currentStep;
                tempObject.candidateName = candidate.candidateName = candidateFirstName + candidateLastName;
                tempObject.message = "";
                tempObject.selected = true;
                tempObject.candidateType = candidate.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
                if (!candidate.email || (candidate.currentStep == 'Released' || candidate.currentStep == 'Not Interested') || candidate.isOutreachDisabled) {
                    if (candidate.isOutreachDisabled) {
                        tempObject.message = "Outreach has already been Submitted.";
                    }
                    else if (candidate.currentStep == 'Released' || candidate.currentStep == 'Not Interested') {
                        tempObject.message = `Cannot Send Outreach to Candidates in '${candidate.currentStep}' State.`;
                    }
                    else {
                        tempObject.message = "Email ID not available.";
                    }
                    notValidCandidatesToSendOutreachEmail.push(tempObject);
                }
                else {
                    validCandidatesToSendOutreachEmail.push(tempObject);
                    if (selectedCandidateJobMatches.length == 1) {
                        selectedJobMatchesForOutreach.push(Object.assign({}, candidate, tempObject));
                    }
                }
            });
            isSingleCandidateSelected = selectedCandidateJobMatches.length == 1 && validCandidatesToSendOutreachEmail.length == 1 ? true : false;
            if (isSingleCandidateSelected) {
                selectedJobMatchesForOutreach[0].outreachActiveJob = true;
                selectedJobMatchesForOutreach[0].requisitionNumber = selectedJobMatchesForOutreach[0].jobMatchRequisitionNum;
                selectedJobMatchesForOutreach[0].jobTitle = selectedJobMatchesForOutreach[0].jobMatchTitle;
                selectedJobMatchesForOutreach[0].companyName = selectedJobMatchesForOutreach[0].clientOrBUName;
                selectedJobMatchesForOutreach[0].jobLocationText = this.jobMatchService.setJobLocationText(selectedJobMatchesForOutreach[0].jobLocation);
                selectedJobMatchesForOutreach[0].jobId = selectedJobMatchesForOutreach[0].jobMatchJobId;
                selectedJobMatchesForOutreach[0].candidateId = selectedJobMatchesForOutreach[0].id;
                windowClass = 'four-dot-five-modal-large';
                candidateId = selectedJobMatchesForOutreach[0].id;
                candidateType = selectedJobMatchesForOutreach[0].candidateType;
            }
            $(".modal").addClass("associate-candidate-modal");
            let label = isSingleCandidateSelected ? `Send outreach to Candidate <b>'${selectedJobMatchesForOutreach[0].candidateName}'</b>` : "Send outreach to Candidates";
            let vm = this;
            this.sendOutreachEmailModal = this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: CandidateSendOutreachEmailModal.default,
                backdrop: 'static',
                windowTopClass: windowClass,
                controller: ['$uibModalInstance', 'label', 'validCandidatesToSendOutreachEmail', 'notValidCandidatesToSendOutreachEmail', 'isSingleCandidateSelected', 'companyId', 'userId', 'candidateId', 'clientOrBUId', 'candidateType', 'selectedJobMatchesForOutreach', 'context', 'salaryDurationOptions', 'jobTypeList',
                    function ($uibModalInstance, label, validCandidatesToSendOutreachEmail, notValidCandidatesToSendOutreachEmail, isSingleCandidateSelected, companyId, userId, candidateId, clientOrBUId, candidateType, selectedJobMatchesForOutreach, context, salaryDurationOptions, jobTypeList) {
                        let ctrl = this;
                        ctrl.label = label;
                        ctrl.validCandidatesToSendOutreachEmail = validCandidatesToSendOutreachEmail;
                        ctrl.notValidCandidatesToSendOutreachEmail = notValidCandidatesToSendOutreachEmail;
                        ctrl.isSingleCandidateSelected = isSingleCandidateSelected;
                        ctrl.companyId = companyId;
                        ctrl.userId = userId;
                        ctrl.candidateId = candidateId;
                        ctrl.clientOrBUId = clientOrBUId;
                        ctrl.candidateType = candidateType;
                        ctrl.selectedJobMatchesForOutreach = selectedJobMatchesForOutreach;
                        ctrl.context = context;
                        ctrl.salaryDurationOptions = salaryDurationOptions;
                        ctrl.jobTypeList = jobTypeList;
                        ctrl.closeModal = () => {
                            $uibModalInstance.close('cancel');
                        };
                        ctrl.saveCallback = () => {
                            if (isSingleCandidateSelected) {
                                ctrl.closeModal();
                                vm.resetCandidateJobMatches();
                            }
                            else {
                                let passedCandidateList = [];
                                if (ctrl.validCandidatesToSendOutreachEmail.length > 0) {
                                    ctrl.validCandidatesToSendOutreachEmail.map(candidate => {
                                        if (candidate.selected) {
                                            passedCandidateList.push({
                                                id: candidate.candidateId,
                                                candidateType: candidate.candidateType,
                                                source: 'JOBMATCH_CARD',
                                                jobIds: [vm.jobId],
                                                jobMatchId: candidate.jobMatchId
                                            });
                                        }
                                    });
                                }
                                if (passedCandidateList.length > 0) {
                                    let outreachObject = {
                                        candidates: passedCandidateList,
                                        userId: vm.userId,
                                        companyId: vm.companyId,
                                        clientOrBuId: vm.jobInfo.clientOrBuId
                                    };
                                    vm.candidateService.sendOutreachEmail(outreachObject, (data) => {
                                        vm.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                                        ctrl.closeModal();
                                        vm.resetCandidateJobMatches();
                                    }, (error) => {
                                        ctrl.closeModal();
                                        vm.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    });
                                }
                                else {
                                    let title = "No candidates selected";
                                    let message = "Please select atleast one candidate.";
                                    vm.alertsAndNotificationsService.showAlert(title, message, "warning");
                                }
                            }
                        };
                        ctrl.cancelCallback = () => {
                            ctrl.closeModal();
                        };
                    }],
                controllerAs: 'sendOutreachEmailModal',
                size: 'lg',
                resolve: {
                    validCandidatesToSendOutreachEmail: () => {
                        return validCandidatesToSendOutreachEmail;
                    },
                    notValidCandidatesToSendOutreachEmail: () => {
                        return notValidCandidatesToSendOutreachEmail;
                    },
                    label: () => {
                        return label;
                    },
                    isSingleCandidateSelected: () => {
                        return isSingleCandidateSelected;
                    },
                    companyId: () => {
                        return vm.companyId;
                    },
                    userId: () => {
                        return vm.userId;
                    },
                    candidateId: () => {
                        return candidateId;
                    },
                    clientOrBUId: () => {
                        return vm.jobInfo.clientOrBuId;
                    },
                    candidateType: () => {
                        return candidateType;
                    },
                    selectedJobMatchesForOutreach: () => {
                        return selectedJobMatchesForOutreach;
                    },
                    context: () => {
                        return 'candidateWorkflow';
                    },
                    salaryDurationOptions: () => {
                        return vm.salaryDurationOptions;
                    },
                    jobTypeList: () => {
                        return vm.jobTypeList;
                    }
                }
            });
        }
        else {
            var statusType = '';
            var windowTopClass = '';
            switch (action) {
                case 'release':
                    windowTopClass = 'four-dot-five-modal-large';
                    statusType = 'Release';
                    break;
                case 'notInterested':
                    windowTopClass = 'four-dot-five-modal-large';
                    statusType = 'Not Interested';
                    break;
                case 'delete':
                    windowTopClass = 'four-dot-five-modal-large';
                    statusType = 'Delete Job Match';
                    break;
                case 'addCandidates':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'addCandidatesFromJobBoards':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'associateCandidates':
                    windowTopClass = 'four-dot-five-modal-extra-large';
                    break;
                case 'sendTechAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'cancelTechAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'sendValueAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'cancelValueAssessment':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
                case 'compareCandidates':
                    windowTopClass = 'four-dot-five-modal-large';
                    if (selectedCandidateJobMatches.length == 3) {
                        windowTopClass = 'four-dot-five-modal-extra-large';
                    }
                    break;
                case 'jobProfile':
                    windowTopClass = 'four-dot-five-modal-large';
                    break;
            }
            let formalizeActivityPayload = {
                candidate: null,
                requisition: new FormalizeRequisition(this.jobId, this.jobInfo.requisitionActualNumber, this.jobInfo.requisitionRole),
                jobMatch: new FormalizeJobMatch(null, this.jobId, this.jobInfo.requisitionActualNumber, this.jobInfo.requisitionRole),
                company: new FormalizeCompany(this.companyId, this.jobInfo.companyName, this.jobInfo.clientOrBuId, this.jobInfo.clientName)
            };
            let actionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: windowTopClass,
                component: 'candidateJobMatchesWorkflowActionsModal',
                resolve: {
                    jobMatchDetailsArray: () => {
                        var tempArray = [];
                        angular.forEach(selectedCandidateJobMatches, (val, key) => {
                            var tempObject = {};
                            tempObject.jobMatchId = val.jobMatchId;
                            tempObject.candidateId = val.id;
                            tempObject.workflowStepName = val.currentStep;
                            tempArray.push(tempObject);
                        });
                        return tempArray;
                    },
                    statusType: () => {
                        return statusType;
                    },
                    jobId: () => {
                        return this.jobId;
                    },
                    clientOrBuId: () => {
                        return this.jobInfo.clientOrBuId;
                    },
                    clientOrBuName: () => {
                        return this.jobInfo.clientName;
                    },
                    isSharedRequisition: () => {
                        return this.jobInfo.sharedRequisition;
                    },
                    corporateCompanyId: () => {
                        return this.jobInfo.corporateId;
                    },
                    corporateCompanyName: () => {
                        return this.jobInfo.corporateName;
                    },
                    lastAddedCandidateSourceTypeId: () => {
                        return this.jobInfo.lastAddedCandidateSourceTypeId;
                    },
                    action: () => {
                        return action;
                    },
                    resumeRequiredForWorkflow: () => {
                        return this.jobInfo.resumeRequiredForWorkflow;
                    },
                    formalizeActivityPayload: () => {
                        return formalizeActivityPayload;
                    }
                }
            });
            actionsModal.result.then((callbackObject) => {
                $('.modal').css("overflow-y", "auto");
                if (callbackObject.callbackType == 'refresh') {
                    this.resetCandidateJobMatches();
                }
            }, dismiss => {
                $('.modal').css("overflow-y", "auto");
                //do nothing;
            });
        }
    }
    toggleColumn(workflowStep) {
        if (workflowStep.isCollapsedFlag) {
            workflowStep.isCollapsedFlag = false;
            this.$timeout(() => {
                workflowStep.showCollapseIconFlag = true;
                workflowStep.expandCollapseLabel = 'Collapse Column';
                workflowStep.countAndLabelTooltipPlacement = 'bottom-right';
            }, 600);
        }
        else {
            workflowStep.isCollapsedFlag = true;
            this.$timeout(() => {
                workflowStep.showCollapseIconFlag = false;
                workflowStep.expandCollapseLabel = 'Expand Column';
                workflowStep.countAndLabelTooltipPlacement = 'right';
            }, 600);
        }
    }
    onFilterItemClick(selectedItems, label) {
        this.isFiltersChanged = true;
        switch (label) {
            case 'JobMatchStates':
                // set the selected job match states on the global query filter object
                this.globalQueryFilterObject.workflowStates = this.selectedJobMatchStates.map((val, index) => {
                    return val.value;
                });
                this.displaySelectedFilterContainer.jobMatchStates = this.globalQueryFilterObject.workflowStates;
                this.displaySelectedFilterContainer.jobMatchStates = this.displaySelectedFilterContainer.jobMatchStates.filter(val => val !== undefined);
                // Filter Duplicate Values
                this.displaySelectedFilterContainer.jobMatchStates = [...new Set(this.displaySelectedFilterContainer.jobMatchStates)];
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            case 'Vendors':
                // set the selected vendors' ids on the global query filter object
                this.globalQueryFilterObject.vendors = this.selectedVendors.map((val, index) => {
                    return val.vendorId;
                });
                this.displaySelectedFilterContainer.vendors = this.selectedVendors.map((val, index) => {
                    return val.vendorName;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            case 'OutreachStates':
                this.globalQueryFilterObject.outreachStateFilters = this.selectedOutreachStates.map((val, index) => {
                    return val.value;
                });
                this.displaySelectedFilterContainer.outreachStateFilters = this.selectedOutreachStates.map((val, index) => {
                    return val.name;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                break;
            default:
            //do nothing;
        }
    }
    filterSelectRemoveAll(label, type) {
        this.isFiltersChanged = true;
        if (type == 'selectAll') {
            switch (label) {
                case 'JobMatchStates':
                    // set the selected job match states on the global query filter object
                    this.globalQueryFilterObject.workflowStates = this.jobMatchStates.map((val, index) => {
                        return val.value;
                    });
                    this.displaySelectedFilterContainer.jobMatchStates = this.globalQueryFilterObject.workflowStates;
                    this.displaySelectedFilterContainer.jobMatchStates = this.displaySelectedFilterContainer.jobMatchStates.filter(val => val !== undefined);
                    // Filter Duplicate Values
                    this.displaySelectedFilterContainer.jobMatchStates = [...new Set(this.displaySelectedFilterContainer.jobMatchStates)];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'Vendors':
                    // set the selected vendors' ids on the global query filter object
                    this.globalQueryFilterObject.vendors = this.vendorsList.map((val, index) => {
                        return val.vendorId;
                    });
                    this.displaySelectedFilterContainer.vendors = this.vendorsList.map((val, index) => {
                        return val.vendorName;
                    });
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'OutreachStates':
                    this.globalQueryFilterObject.outreachStateFilters = this.outreachFilters.map((val, index) => {
                        return val.value;
                    });
                    this.displaySelectedFilterContainer.outreachStateFilters = this.outreachFilters.map((val, index) => {
                        return val.name;
                    });
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                default:
                //do nothing;
            }
        }
        else {
            switch (label) {
                case 'JobMatchStates':
                    // set the selected job match states to empty on the global query filter object
                    this.globalQueryFilterObject.workflowStates = [];
                    this.displaySelectedFilterContainer.jobMatchStates = [];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'Vendors':
                    // set the selected vendors' ids to empty on the global query filter object
                    this.globalQueryFilterObject.vendors = [];
                    this.displaySelectedFilterContainer.vendors = [];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                case 'OutreachStates':
                    this.globalQueryFilterObject.outreachStateFilters = [];
                    this.displaySelectedFilterContainer.outreachStateFilters = [];
                    this.setSelectedFilterItems(this.displaySelectedFilterContainer);
                    break;
                default:
                //do nothing
            }
        }
    }
    dropJobMatchCardCallback(draggableCandidate, droppingToStep) {
        this.jobMatchDragAndDropService.dropJobMatchCardToWorkflowStep(draggableCandidate, droppingToStep, this.workflowStepNames, () => {
            this.resetCandidateJobMatches();
        });
    }
    onDragStart(jobMatchToDrop) {
        if (this.jobMatchDragAndDropService.isMoveBackActionFromNotInterestedOrReleasedStep(jobMatchToDrop)) {
            const currentStep = jobMatchToDrop.currentStep;
            let stepToDropTo = jobMatchToDrop.availableActions.filter(action => {
                return action.actionType == "MOVE_BACKWARD";
            });
            this._removeDisallowedTypesFromSteps(currentStep, stepToDropTo[0]);
        }
    }
    _removeDisallowedTypesFromSteps(currentStepName, stepToDropTo) {
        const stepToDropToName = stepToDropTo.action.replace("Move back to ", "");
        angular.forEach(this.candidatesObject, (step, stepKey) => {
            if (step.workflowStep !== "Not Interested" && step.workflowStep !== "Released" && step.workflowStep !== stepToDropToName) {
                step.allowedDnDTypes = step.allowedDnDTypes.filter(type => {
                    return type !== currentStepName;
                });
            }
        });
    }
    onDragEnd(jobMatchToDrop) {
        if (this.jobMatchDragAndDropService.isMoveBackActionFromNotInterestedOrReleasedStep(jobMatchToDrop)) {
            this._resetAllowedDndTypes();
        }
        this._clearIntervals();
    }
    _resetAllowedDndTypes() {
        angular.forEach(this.candidatesObject, (workflowStep, key) => {
            workflowStep.allowedDnDTypes = [...this.jobMatchDragAndDropService.getAllowedDraggableTypesOfCurrentWorkflowStep(workflowStep.workflowStep, this.workflowStepNames)];
        });
    }
    _drag(e) {
        console.log('drag called');
        var isMoving = false;
        //Left
        if ((e.pageX - this.offset.left) <= this.distance) {
            isMoving = true;
            this._clearIntervals();
            this.intLeftHandler = setInterval(() => {
                this.container.scrollLeft(this.container.scrollLeft() - this.step);
                console.log('left');
            }, this.timer);
        }
        //Right
        if (e.pageX >= (this.offsetWidth - this.distance)) {
            isMoving = true;
            this._clearIntervals();
            this.intRightHandler = setInterval(() => {
                this.container.scrollLeft(this.container.scrollLeft() + this.step);
                console.log('right');
            }, this.timer);
        }
        //No events
        if (!isMoving) {
            this._clearIntervals();
        }
    }
    _clearIntervals() {
        clearInterval(this.intRightHandler);
        clearInterval(this.intLeftHandler);
        clearInterval(this.intTopHandler);
        clearInterval(this.intBottomHandler);
    }
    getOutreachFilters() {
        this.outreachFiltersLoadedFlag = true;
        this.outreachService.getOutreachFilters((data) => {
            this.outreachFilters = data;
            if (this.savedFilters && this.savedFilters.outreachStateFilters && this.savedFilters.outreachStateFilters.length > 0) {
                this.selectedOutreachStates = this.outreachFilters.filter(outreach => this.savedFilters.outreachStateFilters.some(selected => selected == outreach.value));
                this.selectedOutreachStates.forEach(selected => {
                    selected.ticked = true;
                });
                this.globalQueryFilterObject.outreachStateFilters = this.selectedOutreachStates.map((val, index) => {
                    return val.value;
                });
            }
            if (this.savedDisplayedWorkflowSelectedFilter && this.savedDisplayedWorkflowSelectedFilter.outreachStateFilters && this.savedDisplayedWorkflowSelectedFilter.outreachStateFilters.length !== 0) {
                this.displaySelectedFilterContainer.outreachStateFilters = [];
                this.displaySelectedFilterContainer.outreachStateFilters = this.selectedOutreachStates.map((val, index) => {
                    return val.name;
                });
                this.setSelectedFilterItems(this.displaySelectedFilterContainer);
            }
            this.outreachFiltersLoadedFlag = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    $onDestroy() {
        this.webSocketsService.resetWorkflowUpdateListener();
        this.removeJobMatchListener();
    }
}
CandidateJobMatchesWorkflowController.$inject = ['$rootScope', '$state', '$uibModal', '$timeout', 'assessmentService', 'jobMatchDragAndDropService', 'requisitionService', 'companyService', 'jobMatchService', 'jobService', 'planService', 'webSocketsService', 'userRoleService', 'alertsAndNotificationsService', 'debounceService', 'browserService', 'candidateService', 'utilityService', 'outreachService', 'stateManagementStorageService'];
// import * as TEMPLATE from './candidate-job-matches-workflow.html';
import * as TEMPLATE from 'raw-loader!./candidate-job-matches-workflow.html';
export const CandidateJobMatchesWorkflowComponent = {
    selector: 'candidateJobMatchesWorkflow',
    component: {
        bindings: {
            jobId: '@',
            searchString: '@',
            globalQueryFilterObject: '<',
            reqStateData: '<'
        },
        controller: CandidateJobMatchesWorkflowController,
        template: TEMPLATE.default
        // templateUrl: "app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidate-job-matches-workflow.html"
    }
};
//# sourceMappingURL=candidate-job-matches-workflow.component.js.map